module.exports = "/assets/images/89ed7712e7b9b998f6e53c4c639b5af9.svg";